<template>
  <UChip :text="userStore.unreadConversationsCount" :show="userStore.unreadConversationsCount > 0"
         size="3xl" color="success" :ui="{base: 'ring-0 p-1.5'}">
    <UButton variant="ghost" size="xl" type="button" :to="messagePageMoodle" external
             @click="userStore.resetUnreadConversationsCount()"
             class="p-0 bg-transparent hover:bg-transparent transition-transform active:bg-transparent focus:outline-none hover:cursor-pointer group">
      <UIcon name="ph:chat-centered-text"
             :class="[iconClass, 'w-6 h-6 block group-hover:hidden group-focus:hidden group-active:hidden']"/>
      <UIcon name="ph:chat-centered-text-fill"
             :class="[iconClass, 'w-6 h-6 hidden group-hover:block group-focus:block group-active:block']"/>
    </UButton>
  </UChip>
  <!--div>
    <USlideover title="Caso venha a ter um título" side="right" class="p-0 group" v-model:open="abrirMenssagemMenu"
        :ui="customUSliderover">
        <UButton variant="ghost" size="xl" type="button"
            class="p-0 bg-transparent hover:bg-transparent transition-transform active:bg-transparent focus:outline-none hover:cursor-pointer group">
            <UIcon name="ph:chat-centered-text"
                :class="[iconClass, 'w-6 h-6 block group-hover:hidden group-focus:hidden group-active:hidden']" />
            <UIcon name="ph:chat-centered-text-fill"
                :class="[iconClass, 'w-6 h-6 hidden group-hover:block group-focus:block group-active:block']" />
        </UButton>
        <template class="w-20" #body>
            <UInput placeholder="Pesquisar" class="w-full">
                <template #trailing>
                    <UButton variant="ghost" icon="i-ph-magnifying-glass"
                        class="text-gray-900 hover:cursor-pointer hover:opacity-50 hover:bg-transparent active:bg-transparent"
                        :padded="false" />
                </template>
            </UInput>
            <div class="flex justify-end mt-8 mb-2">
                <a href="#" class="flex items-center justify-end hover:underline w-24">
                    <UIcon name="ph:user-fill" class=" mr-1 text-lg" />
                    <p>Contatos</p>
                </a>
            </div>
            <UAccordion :items="itensMenssagem" />
            <UCard>
                <p>
                    Teste de card
                </p>
            </UCard>
        </template>
    </USlideover>
  </div-->
</template>

<script setup lang="ts">
const config = useRuntimeConfig()
const messagePageMoodle = `${config.public.baseURL}/message/index.php`

const userStore = useUserStore()

const abrirMenssagemMenu = ref(false);
const customUSliderover = {
  overlay: 'bg-slate-900/70', //backdrop-blur-sm
  content: 'w-[320px] max-w-[320px]',
}

defineProps({
  iconClass: {
    type: String,
    default: 'text-gray-700' // cor padrão do ícone
  }
})

const itensMenssagem = [
  {
    label: 'Favoritos',
    content: 'Aqui estão suas mensagens recentes.',
    open: true,
  },
  {
    label: 'Grupos',
    content: 'Nenhuma conversa em grupo.',
    open: false,
  },
  {
    label: 'Privados',
    content: 'Nenhuma conversa privada.',
    open: false,
  },
];
</script>